var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Brands',{attrs:{"brands":_vm.brands,"title":_vm.$t('home.design.footer.title'),"height":45,"margin":_vm.margin}})
}
var staticRenderFns = []

export { render, staticRenderFns }